module.exports = __webpack_public_path__ + "static/img/s1.faab9bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/s1.png
// module id = 56I3
// module chunks = 0